import { buildCircuitPathsState } from "./buildCircuitPathsState";
import type { PlanRouteGroupV3 } from "./types";
import type { CircuitPathsState } from "../../ReviewPage/hooks/useCircuitCablePaths/types";

export const buildGroupCircuitPathsState = (
  routeGroups: PlanRouteGroupV3[],
): CircuitPathsState | null => {
  const allPaths: CircuitPathsState["paths"] = [];
  let totalCableLength = 0;

  for (const group of routeGroups) {
    for (const route of group.routes) {
      const result = buildCircuitPathsState({ route, rgb: group.rgb });
      if (result) {
        allPaths.push(...result.paths);
        totalCableLength += result.totalCableLength ?? 0;
      }
    }
  }

  if (allPaths.length === 0) return null;

  return {
    paths: allPaths,
    distributionBoardPosition: null,
    totalCableLength,
  };
};
